import React from 'react';
import { CoreLayout } from '@components/core';
import './src/assets/fonts/typography.css';

export function wrapPageElement({ element, props }) {
  return <CoreLayout {...props}>{element}</CoreLayout>;
}
